/* src/app/front-layout/gcse-help-club/gcse-help-club.component.css */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", sans-serif;
}
.hero-wrapper {
  min-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background:
    linear-gradient(
      135deg,
      #00729d,
      #005f85);
  padding: 70px 20px;
}
.hero-content {
  width: 100%;
  max-width: 2000px;
  margin: 0 auto;
  padding: 0 40px;
}
.hero-title {
  font-size: 46px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 25px;
  margin-top: 100px;
}
.hero-subtitle {
  font-size: 24px;
  color: #fff;
  margin-bottom: 25px;
}
.hero-desc {
  font-size: 19px;
  line-height: 1.7;
  max-width: 1200px;
  margin: 0 auto 50px;
  color: #e9f7ff;
}
.hero-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  margin-bottom: 40px;
}
.info-pill {
  background: rgba(255, 255, 255, .15);
  padding: 15px 60px;
  border-radius: 30px;
  font-size: 14px;
  color: #fff;
}
.info-pill.yellow {
  background: #ffbf00;
  color: #004c6a;
  font-weight: 700;
}
.hero-btn {
  background: #ffbf00;
  border: none;
  padding: 18px 60px;
  border-radius: 40px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  color: #005f85;
  transition: .3s;
  margin-bottom: 100px;
}
.hero-btn:hover {
  transform: scale(1.06);
  box-shadow: 0 12px 28px rgba(0, 0, 0, .35);
}
.hero-right {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 100px;
}
.img-top {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.img-top img {
  width: 100%;
  height: 160px;
  border-radius: 20px;
  object-fit: cover;
  margin-bottom: -130px;
}
.img-top2 img {
  height: 160px;
  border-radius: 20px;
  object-fit: cover;
  margin-left: 280px;
}
.img-bottom img {
  width: 100%;
  height: 300px;
  border-radius: 26px;
  object-fit: cover;
}
.info-section {
  background: #f8fbfd;
  margin-top: 20px;
  padding: 60px 0;
}
.info-card {
  max-width: 1150px;
  margin: auto;
  background: white;
  border-radius: 26px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
  padding: 50px;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 50px;
  align-items: center;
  margin-top: -140px;
}
.info-left h2 {
  font-size: 32px;
  color: #005f85;
  margin-bottom: 18px;
}
.info-left p {
  font-size: 16px;
  line-height: 1.7;
  color: #555;
}
.highlight {
  margin-top: 12px;
  font-weight: 600;
  color: #00729d;
}
.info-right img {
  width: 100%;
  border-radius: 22px;
}
.board-section {
  padding: 50px 0 90px;
  background: #f8fbfd;
}
.board-card {
  max-width: 1150px;
  margin: auto;
  background: white;
  border-radius: 26px;
  padding: 40px 50px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.1);
}
.board-card h2 {
  font-size: 28px;
  color: #005f85;
  margin-bottom: 25px;
}
.boards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  margin-bottom: 16px;
}
.board {
  padding: 16px;
  border-radius: 14px;
  background: #f2f9fc;
  text-align: center;
  font-weight: 600;
  color: #00729d;
  transition: 0.3s;
  cursor: pointer;
}
.board:hover {
  background: #00729d;
  color: white;
  transform: translateY(-4px);
}
.board-card p {
  color: #666;
  font-size: 15px;
}
@media (max-width: 992px) {
  .hero-container,
  .info-card {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .hero-info {
    justify-content: center;
  }
}
.subjects-section {
  background: #f8fbfd;
  padding: 50px 0;
}
.subjects-card {
  max-width: 1150px;
  margin: auto;
  background: #fff;
  border-radius: 26px;
  padding: 40px;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.12);
  text-align: center;
}
.subjects-card h2 {
  font-size: 28px;
  color: #005f85;
  margin-bottom: 25px;
}
.subjects-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.subject-box {
  background: #f6fbff;
  border-radius: 18px;
  padding: 14px;
  transition: .3s;
  cursor: pointer;
}
.subject-box:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, .15);
}
.subject-box img {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 14px;
}
.subject-box p {
  margin-top: 10px;
  font-weight: 600;
  color: #005f85;
}
.subject-note {
  margin-top: 18px;
  color: #777;
}
.gain-section {
  background: #f8fbfd;
  padding: 60px 0;
}
.gain-card {
  max-width: 1150px;
  margin: auto;
  background: white;
  border-radius: 26px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, .12);
  padding: 50px;
  display: grid;
  grid-template-columns: 1.1fr .9fr;
  gap: 40px;
  align-items: center;
}
.gain-left h2 {
  font-size: 30px;
  color: #005f85;
  margin-bottom: 18px;
}
.gain-list {
  list-style: none;
  padding: 0;
}
.gain-list li {
  margin-bottom: 16px;
}
.gain-list strong {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #0c0e0f;
  margin-bottom: 4px;
}
.gain-list span {
  display: block;
  font-size: 14.5px;
  color: #555;
  padding-left: 18px;
  position: relative;
}
.gain-list span::before {
  content: "";
  width: 6px;
  height: 6px;
  background: #ffbf00;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 9px;
}
.gain-right img {
  width: 100%;
  border-radius: 22px;
}
.why-section {
  background: #f8fbfd;
  padding: 40px 0;
}
.why-card {
  max-width: 1150px;
  margin: auto;
  background: #fff;
  border-radius: 26px;
  padding: 40px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, .12);
}
.why-card h2 {
  font-size: 26px;
  color: #005f85;
  margin-bottom: 20px;
}
.why-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}
.why-grid p {
  font-size: 15px;
  color: #555;
}
.who-wrap {
  background: #f6fbff;
  padding: 40px 0;
}
.who-card {
  max-width: 1150px;
  margin: auto;
  background: #ffffff;
  border-radius: 20px;
  padding: 38px 45px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, .12);
}
.who-card h2 {
  font-size: 26px;
  color: #005f85;
  margin-bottom: 22px;
}
.who-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 18px;
}
.who-pill {
  background: #f2f9fc;
  padding: 14px 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #005f85;
  transition: .25s;
  cursor: pointer;
}
.who-pill:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, .15);
}
.cta-wrap {
  background: #f6fbff;
  padding: 60px 0 90px;
}
.cta-box {
  max-width: 1150px;
  margin: auto;
  background:
    linear-gradient(
      135deg,
      #006c96,
      #004c6a);
  border-radius: 22px;
  padding: 55px 60px 60px;
  text-align: center;
  color: #ffffff;
  box-shadow: 0 20px 50px rgba(0, 0, 0, .28);
}
.cta-box h2 {
  font-size: 32px;
  margin-bottom: 8px;
  font-weight: 700;
  color: #e9f7ff;
}
.cta-sub {
  font-size: 15px;
  opacity: .9;
  margin-bottom: 26px;
}
.cta-points {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px 30px;
  max-width: 800px;
  margin: 0 auto 32px;
}
.cta-points span {
  font-size: 14px;
  text-align: left;
  opacity: .95;
}
.cta-btn {
  background: #ffbf00;
  border: none;
  padding: 14px 48px;
  border-radius: 40px;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  color: #005f85;
  transition: .3s;
}
.cta-btn:hover {
  transform: scale(1.07);
  box-shadow: 0 12px 28px rgba(0, 0, 0, .45);
}
@media (max-width: 768px) {
  .cta-points {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 992px) {
  .subjects-grid,
  .why-grid,
  .who-grid,
  .cta-points {
    grid-template-columns: 1fr;
  }
  .gain-card {
    grid-template-columns: 1fr;
    text-align: center;
  }
}
/*# sourceMappingURL=gcse-help-club.component.css.map */
